import Page from "./page";
import { useTranslation } from "react-i18next";
import Main from "../../assets/software/diningCar/main.png";
import qrcode from "../../assets/software/qrcodePink.png";
import Pic1 from '../../assets/software/diningCar/1.png';
import Pic2 from '../../assets/software/diningCar/2.png';
import logo1 from '../../assets/software/diningCar/logo1.png';
import logo2 from '../../assets/software/diningCar/logo2.png';
import u1 from "../../assets/software/u1.png";
import u2 from "../../assets/software/u2.png";
import u3 from "../../assets/software/diningCar/u3.png";
import u4 from "../../assets/software/diningCar/u4.png";
function Pos() {
  let { t } = useTranslation();
  const datas = [
    {
      pic: Pic1,
      logo: logo1,
      title: t("diningCarType.posTitle"),
      infos: [
        t("diningCarType.posInfo1"),
        t("diningCarType.posInfo2"),
        t("diningCarType.posInfo3")
      ],
      bgcolor: "rgb(255,241,240)",
    },
    {
      pic: Pic2,
      logo: logo2,
      title: t("diningCarType.payTitle"),
      infos: [
        t("diningCarType.payInfo1"),
        t("diningCarType.payInfo2"),
        t("diningCarType.payInfo3")
      ],
    },
  ]
  return (
    <Page
      {...{
        title: t("diningCarType.title1"),
        content: t("diningCarType.info1"),
        pic: Main,
        bgColor: "rgba(255, 188, 173, 1)",
        linearGradient: 'linear-gradient(156.74deg, rgba(255, 115, 115, 0.4) 0%, rgba(230, 197, 197, 0.01) 100%)',
        downInfo: {
          bgColor: "rgba(255, 126, 112, 1)",
          qrBgColor: 'rgb(255,241,240)',
          qrcode: qrcode,
          urlName: 'toposify_pos',
          url1: "https://play.google.com/store/apps/details?id=com.htsd.toposify_pos",
          url2: "https://itunes.apple.com/app/id6733223161",
          u1: u1,
          u2: u2,
          u3: u3,
          u4: u4,
          showWin: false
        },
        bodyDatas: datas,
        triangleBg: 'linear-gradient(161.37deg, rgba(230, 197, 197, 0.01) 0%, rgba(255, 115, 115, 0.4) 100%)',
      }}
    />
  );
}

export default Pos;
